import React from "react";
import { createRoot } from "react-dom/client";
import { OpsCenterScreen } from "./features/ops-center/OpsCenterScreen";
import "@no-busy-work/design/tokens.css";
import "@no-busy-work/ui/styles.css";
import "./styles.css";

const root = document.querySelector("#root");
if (!root) {
  throw new Error("ops_center_root_missing");
}

createRoot(root).render(
  <React.StrictMode>
    <OpsCenterScreen />
  </React.StrictMode>
);
